import { useState } from 'react';
import { createPortal } from 'react-dom';
import { CalendarDays } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../lib/api';

const todayIso = () => { const d = new Date(); return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`; };

// Vidéo « À valider » livrée sur Drive (ou Frame validée) → une seule question : le jour de post.
export const PostDayButton = ({ videoId, delivery, onDone, compact = false }) => {
  const [open, setOpen] = useState(false);
  const [day, setDay] = useState(todayIso());
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await api.patch(`/tasks/${videoId}`, { stage: 'to_post', scheduled_post_date: day });
      toast.success(`Post prévu le ${new Date(day + 'T12:00:00').toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' })} ✓`);
      setOpen(false);
      onDone?.();
    } catch (err) { toast.error(err?.response?.data?.detail || 'Erreur'); }
    setBusy(false);
  };
  const stop = (e) => e.stopPropagation();
  return (
    <>
      <span role="button" tabIndex={0} data-testid={`post-day-btn-${videoId}`} onPointerDown={stop} onMouseDown={stop}
        onClick={(e) => { stop(e); setOpen(true); }}
        style={{ display: 'inline-flex', alignItems: 'center', gap: 4, padding: compact ? '2px 8px' : '4px 10px', borderRadius: 999, cursor: 'pointer', background: '#34D399', color: '#06281C', fontFamily: 'Sora', fontWeight: 800, fontSize: compact ? 10 : 11 }}>
        <CalendarDays size={compact ? 10 : 12} />{delivery === 'frame' ? 'Retours faits · jour de post' : 'Choisir le jour de post'}
      </span>
      {open && createPortal(
        <div onClick={() => setOpen(false)} style={{ position: 'fixed', inset: 0, zIndex: 10001, background: 'rgba(3,6,18,0.72)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
          <div data-testid="post-day-dialog" onClick={stop} style={{ width: '100%', maxWidth: 340, background: 'linear-gradient(180deg, #1a2242 0%, #101632 100%)', border: '1px solid rgba(52,211,153,0.3)', borderRadius: 18, padding: 22, color: '#EDF1FB' }}>
            <div style={{ fontFamily: 'Sora', fontWeight: 800, fontSize: 16, marginBottom: 12 }}>C'est quand le jour de post ?</div>
            <input type="date" data-testid="post-day-input" min={todayIso()} value={day} onChange={(e) => setDay(e.target.value)}
              style={{ width: '100%', padding: '10px 12px', borderRadius: 10, background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.14)', color: '#EDF1FB', fontFamily: 'Lexend', fontSize: 14, boxSizing: 'border-box', colorScheme: 'dark' }} />
            <button data-testid="post-day-save" disabled={busy || !day} onClick={save} style={{ marginTop: 14, width: '100%', padding: '11px 0', borderRadius: 10, border: 'none', cursor: 'pointer', background: '#34D399', color: '#06281C', fontFamily: 'Sora', fontWeight: 800, fontSize: 13 }}>
              {busy ? '…' : 'Valider → À poster'}
            </button>
          </div>
        </div>, document.body)}
    </>
  );
};
